import type { FC } from "react";

import type { ListProps } from "@jti/ui/components/List/List";
import { List } from "@jti/ui/components/List/List";

import type { linksListInputs } from "./LinksList.builder";
import { LegacyListStyles } from "./LinksList.builder";

export type LinksListBuilderProps = BuilderComponentProps<typeof linksListInputs>;

const ListStylesMap: Record<LegacyListStyles, ListProps["style"]> = {
  [LegacyListStyles.Standard]: "standard",
  [LegacyListStyles.RelatedResources]: "standard",
  [LegacyListStyles.BlueLinks]: "standard",
  [LegacyListStyles.Arrow]: "quick-links",
  [LegacyListStyles.Footer]: "navigation",
  [LegacyListStyles.Navigation]: "navigation",
  [LegacyListStyles.HorizontalArrows]: "navigation-horizontal",
};

export const LinksList: FC<LinksListBuilderProps> = ({
  listItems,
  title,
  style,
  listClickEvent,
  enableCookieSettings,
}) => {
  if (!listItems || listItems.length === 0) {
    return (
      <div>
        <p>Add links in the builder.io editor to display links</p>
      </div>
    );
  }
  return (
    <List
      style={ListStylesMap[style]}
      listClickEvent={listClickEvent}
      listItems={listItems}
      enableCookieSettings={enableCookieSettings}
      title={title}
    />
  );
};
